

































































































import Vue from "vue";
import { InterfaceConfigServiceProxy, InterfaceConfigFieldServiceProxy } from '@/service-proxies/app-v2/system.service-proxies'
import { CHART_TYPES, DATA_TYPES, INTERFACE_METHODS } from '../commonDef'
import FieldTable from '../components/FieldTable.vue'
const interfaceConfigServiceProxy = new InterfaceConfigServiceProxy()
const interfaceConfigFieldServiceProxy = new InterfaceConfigFieldServiceProxy()
export default Vue.extend({
  components: {
    FieldTable
  },
  props: {
    item: {
      type: Object,
      default: () => ({})
    },
    visible: {
      type: Boolean,
      default: false
    },
    addFlag: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      form: this.$form.createForm(this),
      labelCol: { span: 6 },
      wrapperCol: { span: 16 },
      interfaceTypes:INTERFACE_METHODS,
      submitLoading: false,
      chartTypes: CHART_TYPES,
      fieldsData: [],
      editCol: '',
    };
  },
  computed: {
    title() {
      return this.addFlag ? '新建' : '编辑'
    }
  },
  created() {
    console.log('aaa',this.item)
    if (!this.addFlag) {
      interfaceConfigFieldServiceProxy.getList(this.item.id).then(res => {
        this.fieldsData = res
        this.fieldsData.forEach((re, index) => {
          re.sort = index + 1
        })
        console.log(111, res)
      })
    }
  },
  watch: {
    item(newVal) {
      this.form.setFieldsValue({
        deptName: newVal.deptName,
        sort: newVal.sort,
        parentId: newVal.parentId,
        remark: newVal.remark,
        isEnable:newVal.isEnable
      });
    }
  },
  methods: {
    getEditCol(editCol) {
      this.editCol = editCol
    },
    selectInterface($event) {
      console.log('add', $event)
    },
    close(flag) {
      this.$emit('close', flag)
    },
    reset() {
      this.form.resetFields()
    },
    submit() {
      console.log('form', this.form)
    if (this.editCol !== '') {
        this.$message.error('请操作完成在提交！')
        return
      }
      this.submitLoading = true
      this.form.validateFieldsAndScroll((err: any, values: any) => {
        if (err) {
          this.submitLoading = false
          return
        }
        console.log('baaa', values)
        if (!values.urlType && values.urlType !== 0) {
          this.submitLoading = false
          this.$message.error('请选择接口类型!')
          return
        }
        if (!values.owningChart) {
          this.submitLoading = false
          this.$message.error('请选择所属图表!')
          return
        }
        console.log(1, values)
        if (Array.isArray(values.owningChart)) {
          values.owningChart = values.owningChart.toString()
        }
        let params: any = {}
        Object.assign(params, values)
        const interfaceConfigFieldDTOList = []
        if (this.fieldsData.length > 0) {
          this.fieldsData.forEach(res => {
            interfaceConfigFieldDTOList.push({
              configId: this.item.id,
              dataType: res.dataType,
              isRequired: res.isRequired,
              isSingleChoice: res.isSingleChoice,
              name: res.name,
              dataSource: res.dataSource
            })
          })
        }
        params.interfaceConfigFieldDTOList = interfaceConfigFieldDTOList
        if (this.addFlag) {
          console.log(11111111,params)
          interfaceConfigServiceProxy.save(params).then(
            res => {
                this.submitLoading = false
                if (res) {
                this.$message.success(this.$t('page_theme_submit_success'))
                this.$emit('close', true)
                }
            },
            err => {
                this.submitLoading = false
            }
          )
        } else {
          params.id = this.item.id
          interfaceConfigServiceProxy.update(params).then(
            res => {
                this.submitLoading = false
                if (res) {
                    this.$message.success(this.$t('page_theme_submit_success'))
                    this.$emit('close', true)
                }
            },
            err => {
                this.submitLoading = false
            }
          )
        }
      })
    },
    initChartType(type) {
      if (type) {
        const arr = type.split(',')
        const temp = []
        DATA_TYPES.forEach(res => {
          arr.forEach(re => {
            if (res.value === re) {
              temp.push(res.label)
            }
          })
        })
        return temp.toString()
      }
    },
    sendWpData(data) {
      console.log(222, data)
      this.fieldsData = data
    }
  }
});
